@if (!useEmployeeLookup) {
  <div class="input-group">
    <input #field
           [type]="showLookup ? 'hidden' : 'text'"
           class="form-control"
           [ngModel]="innerValue"
           (ngModelChange)="writeValue($event)"
           [maxlength]="maxlength"
           [required]="required">
    @if (showLookup) {
      <input type="text"
             class="form-control mx-0"
             [(ngModel)]="typeInValue"
             [required]="required"
             (ngModelChange)="writeValue($event)"
             [readOnly]="readOnly || selected">
      <div class="input-group-append">
        @if (innerValue || typeInValue) {
          <button
            type="button"
            class="clear-search"
            (click)="clear()">
            <i class="fas fa-times-circle"></i>
          </button>
        }
        @if (!innerValue) {
          <button
            class="btn btn-action"
            (click)="showSearch = true"
            type="button">
            <reporter-icon icon="Search"></reporter-icon>
          </button>
        }
      </div>
    }
  </div>
} @else {
  <reporter-employee-lookup-by-id
    [locationId]="locationId"
    [required]="required"
    (selectContact)="select($event)">
  </reporter-employee-lookup-by-id>
}

@if (showSearch) {
  <reporter-contacts-search
    [show]="showSearch"
    (close)="close()"
    (selectContact)="select($event)"
    [contactType]="contactType">
  </reporter-contacts-search>
}

